import styled from '@/styles';

export const StepContent = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '40px 24px 100px',
  boxSizing: 'border-box',
  width: '100%',
});

export const ContentWrap = styled('div', {
  width: '100%',
  maxWidth: 802,
  display: 'flex',
  flexDirection: 'column',
  gap: 40,
});

export const StepTitle = styled('h2', {
  fontSize: 18,
  fontWeight: 700,
  color: '#1C1C1C',
  margin: 0,
  fontFamily: "'Manrope', sans-serif",
});

export const FieldGroup = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: 20,
  variants: {
    spacing: {
      tight: { gap: 12 },
    },
  },
});

export const FieldLabel = styled('p', {
  fontSize: 14,
  fontWeight: 600,
  color: '#1C1C1C',
  margin: 0,
  fontFamily: "'Manrope', sans-serif",
});

export const RequiredMark = styled('span', {
  color: '#E53E3E',
  marginLeft: 2,
});

export const UniformGrid = styled('div', {
  display: 'flex',
  flexWrap: 'wrap',
  gap: 12,
});

export const UniformTile = styled('button', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 8,
  width: 132,
  padding: 12,
  borderRadius: 8,
  border: '1px solid #DADADA',
  background: '#fff',
  cursor: 'pointer',
  fontFamily: "'Manrope', sans-serif",
  textAlign: 'center',
  transition: 'border-color 0.15s, box-shadow 0.15s',
  '&:hover': {
    borderColor: '#44A735',
  },
  variants: {
    selected: {
      true: {
        borderColor: '#44A735',
        boxShadow: '0 0 0 2px rgba(68,167,53,0.15)',
      },
    },
  },
});

export const UniformImage = styled('div', {
  width: 96,
  height: 96,
  borderRadius: 6,
  background: '#F5F5F5',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden',
  '& img': {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
});

export const UniformLabel = styled('span', {
  fontSize: 13,
  fontWeight: 600,
  color: '#1C1C1C',
  fontFamily: "'Manrope', sans-serif",
});

export const InstructionsTextarea = styled('textarea', {
  width: '100%',
  height: 120,
  border: '1px solid #DADADA',
  borderRadius: 8,
  padding: 16,
  fontSize: 14,
  fontFamily: "'Manrope', sans-serif",
  color: '#1C1C1C',
  resize: 'vertical',
  outline: 'none',
  boxSizing: 'border-box',
  background: '#fff',
  lineHeight: 1.6,
});

export const TextareaActions = styled('div', {
  display: 'flex',
  gap: 16,
  alignItems: 'center',
  justifyContent: 'flex-end',
});

export const LinkButton = styled('button', {
  background: 'none',
  border: 'none',
  fontSize: 12,
  fontWeight: 600,
  color: '#2E8722',
  fontFamily: "'Manrope', sans-serif",
  cursor: 'pointer',
  padding: 0,
  '&:disabled': {
    opacity: 0.4,
    cursor: 'not-allowed',
  },
});

export const ActionDivider = styled('div', {
  borderLeft: '1px solid #DADADA',
  paddingLeft: 16,
  display: 'flex',
  alignItems: 'center',
});
